import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import MainView from '@/pages/MainView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    // redirect: { name: 'stream' },
    component: MainView
  },
  {
    path: '/stream',
    name: 'stream',
    component: () => import('@/pages/StreamView.vue')
  },
  {
    path: '/next-lector',
    name: 'next-lector',
    children: [
      {
        path: ':id',
        name: 'next-lector-details',
        component: () => import('@/pages/StreamPartLector.vue'),
      },
      {
        path: ':id/stand',
        name: 'next-lector-stand',
        component: () => import('@/pages/stand/StreamPartLectorStand.vue'),
      },
    ],
  },
  {
    path: '/lector/:id',
    name: 'lector',
    component: () => import('@/pages/StreamPart.vue'),
  },
  {
    path: '/lector-stand/:id',
    name: 'lector-stand',
    component: () => import('@/pages/stand/StreamPartStand.vue'),
  },
  {
    path: '/final-summary/:id',
    name: 'final-summary',
    component: () => import('@/pages/FinalSummary.vue')
  },
  {
    path: '/final-summary-stand/:id',
    name: 'final-summary-stand',
    component: () => import('@/pages/stand/FinalSummaryStand.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('@/pages/ScheduleView.vue')
  },
  {
    path: '/all-summary',
    name: 'all-summary',
    component: () => import('@/pages/AllSummary.vue')
  },
  {
    path: '/summary/:roomId',
    name: 'summary',
    component: () => import('@/pages/SummaryView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router;

// let arr = [
//   7.228915662650602,
//   3.614457831325301,
//   4.216867469879518,
//   5.542168674698795,
//   1.9277108433734942,
//   2.4096385542168677,
//   2.1686746987951806,
//   16.867469879518072,
//   3.614457831325301,
//   0.24096385542168677,
//   6.024096385542169,
//   39.75903614457831,
//   8.795180722891565,
//   5.903614457831325,
//   13.855421686746988,
//   2.289156626506024,
//   1.9277108433734942,
//   2.4096385542168677,
//   15.180722891566264,
//   7.228915662650602,
//   5.542168674698795,
//   3.614457831325301,
//   3.614457831325301,
//   2.6506024096385543,
//   1.9277108433734942,
//   37.34939759036144,
//   2.4096385542168677,
// ];

// console.log(arr?.map(i => (i / 830) * 100));
